import { render, staticRenderFns } from "./editarTelefono.vue?vue&type=template&id=3a895cd8&"
import script from "./editarTelefono.vue?vue&type=script&lang=ts&"
export * from "./editarTelefono.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports